import { AssignTree, ResponseDataPaginate } from 'src/types'

export enum TreeActionTypes {
  GET_TREE = '@tree/GET_TREE',
  GET_TREE_FAILURE = '@tree/GET_TREE_FAILURE',
  GET_TREE_SUCCESS = '@tree/GET_TREE_SUCCESS'
}

export type ResponseDataRequests = ResponseDataPaginate &
  ResponseDataRequestTotals & {
    requests: AssignTree[]
  }

export type ResponseDataRequestTotals = {
  request_totals: {
    total_emissions: number
    total_quotations: number
  }
}

export type TreeState = ResponseDataRequestTotals & {
  readonly error: string
  readonly list: AssignTree[]
  readonly loading: boolean
  readonly sendTreeError: string
  readonly sendTreeLoading: boolean
  readonly total_results: number
}
